import React, {
  Suspense,
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import { motion, useInView } from "motion/react";
import "../index.css";
import InnovationSvg from "../assets/SVG/Innovation.svg";
import IndustrieSvg from "../assets/SVG/Industries.svg";
import ClientCentricSvg from "../assets/SVG/Client.svg";
import ParticleAnimation from "./ParticleAnimation";
import { SplitText } from "./Animations";
import { useNavigate } from "react-router-dom";

const CoalerPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animationFinished, setAnimationFinished] = useState(false);
  const secRef = useRef(null);
  const contentRef = useRef(null);
  const isInView = useInView(secRef, { amount: 0.5, once: true });
  const isContentInView = useInView(contentRef, { amount: 0.5, once: true });
  const navigate = useNavigate();

  return (
    <section className="-z-50" id="coalerdesc">
      <div className="relative w-full min-h-[832px] overflow-hidden max-w-screen-2xl mb-12 mx-auto flex items-center justify-center px-4">
        {/* Curl at right */}
        <div className="absolute bottom-0 right-0 hidden w-full overflow-hidden md:block">
          <svg className="w-full h-full" preserveAspectRatio="none" viewBox="0 0 1360 1349" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1360 0H0V1346.5H603H986H1004L1323 1224.5L1348 1213.5L1360 1187V0Z" fill="grey" />
            <path d="M1360 0H0V1349H1001C1001 1349 1076.64 1312.31 1111 1273C1151.6 1226.54 1176 1129 1176 1129C1176 1129 1242 1221.5 1279.5 1221.5C1317 1221.5 1349.48 1228.57 1360 1197.5C1360.13 1185.29 1360 1164.5 1360 1164.5V0Z" fill="#151515" />
          </svg>
        </div>

        {/* Light Ray Gradient */}
        <div className="absolute top-4 left-0 w-full h-full pointer-events-none">
          <div className="absolute -top-[60px] w-[170px] h-[264px] left-15 md:-top-[30px] md:left-20 md:w-[246px] md:h-[502px]" style={{
            background: 'linear-gradient(110deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.5) 40%, transparent 70%)',
            transform: 'rotate(-80deg)',
            filter: 'blur(20px)',
          }} />
        </div>

        {/* Content Grid */}
        <div className="relative z-10 w-full max-w-7xl grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-items-center md:justify-items-stretch mb-7">
          {/* Left Side Content */}
          <div className="flex flex-col items-center text-center md:items-start md:text-left">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-[60px] h-[62px] rounded-md flex items-center justify-center">
                <img src="/Logoicon.png" className="w-[34px] h-[34px] md:w-[60px] md:h-[62px]" />
              </div>
              <h2 className="font-bold text-[25px] md:text-[50px] leading-[160%] tracking-normal text-white">
                Introducing Coaler
              </h2>
            </div>
            <h3 className="font-inter font-black text-[20px] md:text-[32px] leading-[100%] tracking-normal text-white mb-4">
              Revolutionizing the <span className="text-purple-500">Coal Industry</span>
            </h3>
            <p className="text-gray-300 mb-1 font-semibold text-[18px] leading-[160%] tracking-normal max-w-xl">
              At Starlabs, we don’t just offer digital solutions—we build future-ready
              ventures. Coaler is one of our flagship initiatives: a dedicated eCommerce
              platform designed to modernize the coal trading ecosystem.
            </p>
            <p className="text-gray-300 mb-1 font-semibold text-[18px] leading-[160%] tracking-normal max-w-xl">
              Whether you're a vendor, buyer, or logistics partner, Coaler simplifies the entire
              supply chain making coal transactions transparent, efficient, and reliable.
            </p>
            <p className="text-gray-300 mb-6 font-semibold text-[18px] leading-[160%] tracking-normal max-w-xl">
              Coaler is more than just a platform—it’s a movement to digitize and democratize
              an industry that’s long needed a transformation.
            </p>
            <button className="hidden md:block border-white text-white hover:bg-white hover:text-black px-6 py-2 rounded-3xl border-2 transition-all duration-300" onClick={() => navigate("/coaler")}>
              Explore Coaler
            </button>
          </div>

          {/* Right Side Image */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="flex justify-center items-center"
          >
            <img
              src="/getearly.png"
              alt="Coaler platform illustration"
              className="max-w-full h-auto"
            />
          </motion.div>

          <button className=" md:hidden border-white text-white hover:bg-white hover:text-black px-6 py-2 rounded-3xl border-2 transition-all duration-300" onClick={() => navigate("/coaler")}>
              Explore Coaler
            </button>
        </div>
      </div>
    </section>
  );
};

export default CoalerPage;
